const dinner = [
  {
    id: 1,
    name: "Plain Rice",
    price: "£5.20"
  },
  {
    id: 2,
    name: "Jeera Rice",
    price: "£6.90"
  },
  {
    id: 3,
    name: "Jeera Rice (with Tadka Dal)",
    price: "£9.80"
  },
  {
    id: 4,
    name: "Plain Khichdi with Kadhi",
    description: "A popular Western Indian comfort food, combining a creamy, yogurt-based curry (kadhi) with a spiced rice and lentil dish (khichdi).",
    price: "£7.40"
  },
  {
    id: 5,
    name: "Masala Khichdi with Kadhi",
    price: "£7.90"
  },
  {
    id: 6,
    name: "Tawa Pulao",
    description: "A popular Mumbai street food, rice and vegetables pan-sauteed with aromatic spices mainly Pav-Bhaji Masala",
    price: "£5.95"
  },
  {
    id: 7,
    name: "Veg Biryani",
    description: "Popular dish from Hyderabad (south-east India), special mint-flavoured rice with paneer and other vegetables. Served with Raita.",
    price: "£11.20"
  },
  {
    id: 8,
    name: "Tadka Dal",
    description: "Boiled split lentils, mixed with aromatic spices and tempered with jeera (cumin), dry red chillies",
    price: "£5.25"
  },
  {
    id: 9,
    name: "Chicken Dum Biryani",
    description: "A fragrant and flavourful Indian dish featuring tender chicken marinated in yogurt and spices, layered with basmati rice, and slow-cooked in a sealed pot to lock in the rich, aromatic flavors - garnished with fried onions and saffron.",
    price: "£11.80"
  },
  {
    id: 10,
    name: "Chicken Tikka Biryani",
    description: "Tender pieces of succulent, marinated chicken tikka, grilled to perfection and infused with aromatic spices, layered with fragrant basmati rice and slow-cooked - garnished with fried onions and saffron.",
    price: "£11.80"
  },
  {
    id: 11,
    name: "Chicken Shahi Kabab Biryani",
    description: "Tender pieces of pan-cooked minced chicken balls infused with aromatic spices and layered with fragrant basmati rice, slow-cooked - garnished with fried onions and saffron.",
    price: "£12.50"
  },
  {
    id: 12,
    name: "Egg Fried Rice",
    price: "£7.95"
  },
  {
    id: 13,
    name: "Lamb Tikka Biryani",
    description: "Tender pieces of succulent, marinated lamb tikka, grilled to perfection and infused with aromatic spices, layered with fragrant basmati rice and slow-cooked - garnished with fried onions and saffron.",
    price: "£13.80"
  },
  {
    id: 14,
    name: "Prawn Biryani",
    description: "Succulent prawns simmered in a rich blend of aromatic spices and layered with fluffy basmati rice - garnished with fried onions and saffron.",
    price: "£14.50"
  }
];
export default dinner;